module.exports = __webpack_public_path__ + "static/media/tuanjian2.16827c5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tuanjian2.mp4
// module id = wD7P
// module chunks = 1